<template>
    <client-page class="wrap--sub">
        <sub-visual :visual="typeName" :class="typeClass" />
        <div class="contents">
            <div class="container">
                <template v-if="isAuthorized">
                    <div class="mb-15">
                        <h3 class="text-28 text-md-20">{{ typeName }} 신청</h3>
                    </div>

                    <div class="row-v-table">
                        <write-area v-model="request._area" />
                        <write-duration v-if="isLong" v-model="request" />
                        <counsel-card-row label="제목">
                            <v-text-field v-model="request.title" outlined hide-details />
                        </counsel-card-row>
                        <counsel-card-row label="상세내용">
                            <v-textarea v-model="request.content" />
                        </counsel-card-row>
                        <write-files v-model="request.files" />
                    </div>

                    <div class="board-buttons board-buttons--right-center">
                        <div class="left"></div>
                        <div class="right">
                            <v-btn outlined color="gray-9" @click="$router.go(-1)">취소</v-btn>
                            <v-btn color="primary" @click="save">신청</v-btn>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <v-row justify="center">
                        <v-col cols="auto">
                            권한이 없습니다.
                        </v-col>
                    </v-row>
                </template>
            </div>
        </div>
    </client-page>
</template>

<script>
import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "../../templates/ClientPage.vue";
import api from "@/api";
import CounselCard from "@/components/client/counsel/counsel-card.vue";
import CounselCardRow from "@/components/client/counsel/counsel-card-row.vue";
import WriteArea from "@/components/client/counsel/write-area.vue";
import WriteFiles from "@/components/client/counsel/write-files.vue";
import { COUNSEL_REQUEST_TYPES } from "@/assets/data/CONSTANTS";
import WriteDuration from "@/components/client/counsel/write-duration.vue";

export default {
    components: { ClientPage, SubVisual, CounselCard, CounselCardRow, WriteArea, WriteFiles, WriteDuration },
    computed: {
        type() {
            return this.$route?.params?.type;
        },
        typeClass() {
            if (this.type == "short") return "sv3";
            if (this.type == "long") return "sv4";
            return "";
        },
        typeName() {
            if (this.type == "short") return "이음자문";
            if (this.type == "long") return "멘토링";
            return "";
        },
        isLong() {
            return this.type == "long";
        },
        isAuthorized() {
            return ["organization"].some((scope) => this.$store.state.payload.scope?.includes(scope));
        },
    },
    data() {
        return {
            request: {
                _area: null,
                title: null,
                content: null,
                files: [],
            },
        };
    },
    methods: {
        async save() {
            try {
                if (this.type && this.isAuthorized) {
                    const { files, ...requestData } = this.request;
                    if (!requestData._area) throw new Error("분야를 선택하셔야 합니다.");
                    const { counselRequest } = await api.v1.counsels.post({ ...requestData, type: this.isLong ? COUNSEL_REQUEST_TYPES.LONG : COUNSEL_REQUEST_TYPES.SHORT });

                    for (const file of files) {
                        await api.v1.counsels.files.post({ _request: counselRequest._id }, file);
                    }

                    alert("신청이 완료되었습니다.");
                    this.$router.push(`/counsel/${this.type}/${counselRequest._id}`);
                }
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    mounted() {
        if (!this.type || !this.isAuthorized) {
            alert("권한이 없습니다.");
            this.$router.go(-1);
        } else if (!["short", "long"].includes(this.type)) {
            alert("올바르지 않은 요청입니다.");
            this.$router.go(-1);
        }
    },
};
</script>

<style></style>
